export default "__VITE_ASSET__BrC5VQLj__"